module.exports = __webpack_public_path__ + "static/media/onboarding_categories.ebe6572f.jpg";